import api from './api';

export const getNotifications = () => {
  return api.get('/v1/api/notifications');
};

export const markAllNotificationsAsRead = () => {
  return api.put('/v1/api/notifications/mark-read');
};

export const markNotificationAsRead = (id) => {
  return api.put(`/v1/api/notifications/${id}/mark-read`);
};
